import { useTranslation } from 'react-i18next';
import { type FC } from 'react';
import BooleanSelectBox from 'components/molecules/boolean-select-box';

import s from './styles.module.scss';

interface IProps {
  value?: boolean;
  updateFilter: <T>(newFilter: Partial<T>) => void;
}

export const CcmInteractionStatusSelect: FC<IProps> = ({
  value,
  updateFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s['select-wrapper-accounts']}>
      <label className={s['select-label']}>
        <span>{t('labels.ccmInteractionStatus')}:</span>
        <BooleanSelectBox
          value={value}
          onChange={(val) =>
            updateFilter({
              ccmInteractionStatus: val,
              'p-page': 1,
            })
          }
        />
      </label>
    </div>
  );
};
